// react
import styled from 'styled-components';

// components
import {
  ActionPlanHeader,
  Container,
  MemphisVariant,
  Title,
} from '@/components/atoms';
import { ActionPlanList } from '@/components/organisms';

// models
import { ActionPlanCategory as ActionPlanCategoryType } from '@karehero/models';

interface ActionPlanCategoryProps {
  className?: string;
  actionPlanCategory?: ActionPlanCategoryType;
}

/**
 * ActionPlanCategory displays a list of action plan items.
 */
export const ActionPlanCategory = ({
  className,
  actionPlanCategory,
}: ActionPlanCategoryProps) => {
  return (
    <Wrapper className={className}>
      <ActionPlanHeader
        color={actionPlanCategory?.color}
        memphis={actionPlanCategory?.headerMemphis as MemphisVariant}
      />
      <Container size='md'>
        {actionPlanCategory && (
          <Body>
            <TitleWrapper>
              <Title size='sm' isNoMargin>
                {actionPlanCategory?.title}
              </Title>
              <SubTitle>{actionPlanCategory?.subTitle}</SubTitle>
            </TitleWrapper>
            <ActionPlanList
              actionPlanCategory={actionPlanCategory}
              actionPlanItems={actionPlanCategory?.actionPlanItems}
            />
          </Body>
        )}
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[24]};
  padding-bottom: ${(props) => props.theme.spacing[48]};
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[16]};
`;

const SubTitle = styled.div`
  font: ${(props) => props.theme.typography.body.md.regular};
  color: ${(props) => props.theme.color.neutral[90]};
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing[24]};
`;

ActionPlanCategory.displayName = 'ActionPlanCategory';

export default ActionPlanCategory;
